import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

export class LocationLinkBuilderServant {
  createLocationLink(locationObject: any): string {
    return `${this.getBaseURL()}${this.getSubURL(locationObject)}`;
  }

  getSubURL(locationObject: any): string {
    let subURL = '';

    if (!_4.isEmpty(locationObject) && !_4.isEmpty(locationObject.address)) {
      subURL = locationObject.address;
    } else if (!_4.isEmpty(locationObject) && locationObject.longitude !== 0 && locationObject.latitude !== 0) {
      subURL = `${locationObject.latitude},${locationObject.longitude}`;
    }

    return subURL;
  }

  private getBaseURL(): string {
    if (PlatformUtility.isAndroid()) {
      return 'geo://maps.google.com/?q=';
    } else if (PlatformUtility.isIOS()) {
      return 'maps://maps.apple.com/?q=';
    } else {
      return 'https://maps.google.com/?q=';
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/servants/location_link_builder_servant.ts